module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAPdJREFUOBHtkz0KwkAQRkMEa01lJyKoYGvpHaw8gp0gHsEDCIK9h7BQglh5ABur4AVELLTQwp/4gk0YdpdsAhbiwIOdb2a+HTbEcf7x1RcIwzAA2wisl+SGBYygbD2sG8DMhRtE8QQfupDXzSTSMaiAKo6IY6iZjFxDsa6peegFOGvqZpmNBqp10TbmyU81zcZtzDtJzJU9DK/hCgeQsUcwfkTTxltujN65p7i5ijZU6HYS263kyuQXKNk5iW4MmvAAGTPRap/iOJWu5C9o2bvFJjDw4AQy5rG2dEcc+zHXO+cJRD9LtsAkBztYQiObm5jGsCikH0nfgIhSCrQSUpAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ZalighUp_normal.png
// module id = 329
// module chunks = 0